<div class="shell" [class.sidebar-collapsed]="sidebarCollapsed()">
  <nf-sidebar
    [collapsed]="sidebarCollapsed()"
    (collapsedChange)="sidebarCollapsed.set($event)"
    [mobileOpen]="mobileMenuOpen()"
    (mobileOpenChange)="mobileMenuOpen.set($event)"
  />

  <div class="shell-main">
    <nf-header (menuToggle)="onToggleMobile()" />

    <main class="shell-content" [@routeAnimation]="getRouteAnimationData()">
      <router-outlet />
    </main>
  </div>
</div>
